import { cn } from '@shadcn/lib/utils';

import { TocCardState } from './toc-card';

type TocCardWrapperProps = {
  readonly children: React.ReactNode;
  readonly isFirst?: boolean;
  readonly isLast?: boolean;
  readonly state: TocCardState;
};

const TocCardWrapper = ({ children, isFirst = false, isLast = false, state }: TocCardWrapperProps) => {
  return (
    <div
      className={cn(
        "relative pb-[24px] before:absolute before:content-[''] before:top-0 before:bottom-0 before:left-[8px] before:w-[5px] before:[background-image:linear-gradient(0deg,rgba(0,0,0,0)_0,rgba(0,0,0,0)_50%,var(--color-neutral-400)_50%,var(--color-neutral-400)_100%)] before:[background-size:100%_12px] before:bg-repeat",
        "after:absolute after:content-[''] after:block after:left-[8px] after:w-[5px] after:top-0 after:bottom-0 after:z-[10]",
        isFirst && 'before:top-[calc(50%-_12px)] after:top-[calc(50%-_12px)]',
        isLast && 'before:bottom-[calc(50%-_12px)]',
        state === 'in-progress' &&
          'after:border-l-[5px] after:border-solid after:border-l-[var(--color-green-400)] after:bottom-[calc(50%+_12px)]',
        state === 'done' && 'after:border-l-[5px] after:border-solid after:border-l-[var(--color-green-400)]',
        isLast && state === 'done' && 'after:bottom-[calc(50%+_12px)]'
      )}
    >
      {children}
    </div>
  );
};

export { TocCardWrapper };
